import React from 'react';
import { ArrowDown, Calendar } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
import { translations } from '../data/translations';
import { BOOKING_URL } from './Booking';

const Hero: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://i.imgur.com/6WDAdad.png)',
        }}
      >
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="space-y-4 sm:space-y-6 lg:space-y-8 animate-fade-in">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-serif font-bold text-white leading-tight">
            {t.heroTitle}
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/90 font-sans font-light max-w-2xl mx-auto leading-relaxed">
            {t.heroSubtitle}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center pt-4 sm:pt-6 lg:pt-8">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-black hover:bg-gray-800 text-white font-sans font-semibold rounded-2xl transition-all duration-300 hover:scale-105 shadow-lg text-sm sm:text-base touch-target"
            >
              <Calendar className="h-4 w-4 sm:h-5 sm:w-5" />
              {t.bookAppointment}
            </a>
            <a
              href="#services"
              className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-white hover:bg-light-gray text-black font-sans font-semibold rounded-2xl transition-all duration-300 hover:scale-105 shadow-lg text-sm sm:text-base touch-target"
            >
              {t.viewServices}
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 border-2 border-white hover:bg-white hover:text-black text-white font-sans font-semibold rounded-2xl transition-all duration-300 hover:scale-105 text-sm sm:text-base touch-target"
            >
              {t.contactUs}
            </a>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ArrowDown className="h-5 w-5 sm:h-6 sm:w-6 text-white/70" />
        </div>
      </div>
    </section>
  );
};

export default Hero;